<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 md6></v-flex>
      <v-flex xs12 md3 style="text-align: end;">
        <a v-if="myPermissions.includes(17)"
          :disabled="!link"
          :href="link"
          target="_blank"
          style="text-decoration: none;">
          <v-btn color="secondary" :disabled="!link" :style="dark_t?'color:black':''">
            <v-icon></v-icon>
            <span>Exportar Excel</span>
          </v-btn>
        </a>
        <!-- <v-btn color="secondary"  @click="exportExcel" v-if="myPermissions.includes(17)" :style="dark_t?'color:black':''">
          <v-icon></v-icon>
          <span>Exportar Excel</span>
        </v-btn> -->
      </v-flex>
      <v-flex xs12 md3 style="text-align: end;">
        <label for="file-upload-metrics" class="custom-file-upload textAlignCenter fullWidth" v-if="myPermissions.includes(15)">
          <v-icon>attach_file</v-icon>
          <fs1-span> Cargar Métricas</fs1-span>
          <input id="file-upload-metrics" class="btn" type="file" @change="selectFile($event.target.files)">
        </label>
        <fs1-div>Fecha de última carga: {{formalDateFormat(sheet_update)}}</fs1-div>
      </v-flex>
    </v-layout>

    <br>
    <v-layout>
      <v-flex md3></v-flex>
      <v-flex md6>
        <Bar :id="'grafMET_1'"
        :options="options"
          :datasets.sync="dataBar.datasets"
          :labels.sync="dataBar.labels"
          :onClick="openModalBar"/>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex md12>
        <Table :data.sync="array" :openModalTable="openModalTable"/>
      </v-flex>
    </v-layout>
    <br>
    <br>
    <v-layout>
      <v-flex md12>
        <ReportTable :openModalTable="openModalTable"/>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dialog" :width="'80%'">
			<v-card class="fullHeight pa-20">
				<h2>{{title}}</h2>
				<br>
				<MetricsByArea :preFilters.sync="preFilters" :table_type="table_type"/>
				<div class="textAlignCenter">
					<v-btn @click="dialog = false" color="secondary">
						<fs1-span>Cerrar</fs1-span>
					</v-btn>
				</div>
			</v-card>
    </v-dialog>
    
  </div>
</template>
<script>
import Table from '@/modules/CA_SP/components/metrics/Metrics.vue';
import ReportTable from '@/modules/CA_SP/components/metrics/ReportTable.vue';
import MetricsByArea from '@/modules/CA_SP/components/metrics/MetricsByArea.vue';
import Bar from '@/components/graphs/MultipleBar.vue';
import { mapGetters } from 'vuex';
import { 
  GET,
  uploadPwoSheet,
  getExportMetrics as exportExcel } from '@/requests/ac';
import SheetUpdate from '@/components/mixins/SheetUpdate';

export default {
  mixins:[SheetUpdate],
  data() {
    return {
      table_type:null,
      exportMetric:null,
      preFilters:{},
      sheet_update_key:'metrics',
      selectedFiltered: [],
			filter: {functionalLocation: '', grcId :''},
      title: '',
      dialog: false,
      options: {
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              var label = tooltipItem.label + ': ' + tooltipItem.value + '%';
              return label;
            }
          }
        }
      }
    };
  },
  async created() {
    if(!await this.assignAccess()) return;
    fetch('https://public-files.ac.dev.bhp.lifeon.cl/public_file/12/',
	    GET())
      .then(res => res.json())
      .then(r => this.exportMetric = r)
      .catch(e => this.getError(e));
  }, // created
  computed: {
    ...mapGetters({
      organizations: 'organizations',
      pwoCancelleds: 'pwoCancelleds',
      pwoOverdues: 'pwoOverdues',
      pwoCompliances: 'pwoCompliances',
      dashboard_metrics_percentage:'dashboard_metrics_percentage',
    }),
    link(){ return this.exportMetric ? this.exportMetric.file : null},
    array() {
      const types = Object.keys(this.dashboard_metrics_percentage);
      if (types.length) {
        const areas = Object.keys(this.dashboard_metrics_percentage[types[0]]);
        const array = [];
        areas.forEach(name => {
          array.push({
            name,
            compliancesTotal: this.dashboard_metrics_percentage['Compliance'][name],
            cancelledsTotal: this.dashboard_metrics_percentage['Cancelled'][name],
            overduesTotal: this.dashboard_metrics_percentage['Overdue'][name],
          })
        })
        return array;
      }
      return []
    },
    dataBar() {
      const dataBar = {labels: [], datasets: []};
      const dataCancelleds = [], dataOverdues = [], dataCompliances = [];

      const color = this.dark_t? ['#4165ac','#568fab','#d77b38'] : ['#CE6428','#a5a5a5','#5a5959'];
      this.array.forEach(o => {
        dataBar.labels.push(o.name);
        dataCompliances.push(o.compliancesTotal);
        dataCancelleds.push(o.cancelledsTotal);
        dataOverdues.push(o.overduesTotal);
      })
      dataBar.datasets = [
        {
          label: 'Compliances',
          data: dataCompliances,
          backgroundColor: color[0],
          borderColor: color[0],
        },
        {
          label: 'Cancelleds',
          data: dataCancelleds,
          backgroundColor: color[1],
          borderColor: color[1],
        },
        {
          label: 'Overdues',
          data: dataOverdues,
          backgroundColor: color[2],
          borderColor: color[2],
        },
      ];
      return dataBar;
    },
  },
  components: { Table, Bar, MetricsByArea,ReportTable },
  watch: { },
  methods: {
		async exportExcel(){
      this.setProgress({show:true,message:'Cargando...'});
			if(!await this.assignAccess()) return;
			exportExcel(this.filter)
        .then(r => this.setProgress({show:false}))
        .catch(e => this.getError(e));
		},
    openModalBar(ev, array,selected) {
      const {label,datasetLabel} = selected[0]._model;
      const pwo_type_name = {Compliances:'Compliance',Cancelleds:'Cancelled',Overdues:'Overdue'}
      this.preFilters = {
        pwo_type:pwo_type_name[datasetLabel],
        organization:label,
        current_fiscal_year:true,
      }

      this.title = `${label} - ${this.preFilters.pwo_type}`;
      
			this.dialog = true;
    },
    openModalTable(item,key,type) {
      this.table_type = type;
      const {pwo_type,organization} = item;

      this.preFilters = {
        pwo_type,
        organization,
        current_fiscal_year:true,
        pwo_time:key,
      }
      this.title = organization;
      if (this.preFilters.pwo_type) this.title += ` - ${this.preFilters.pwo_type}`;
      if (this.preFilters.pwo_time) this.title += ` - ${this.preFilters.pwo_time}`;
            
			this.dialog = true;
    },
    async selectFile(files) { // files no es un array por lo que sus proto funciones no aplican
      if(!await this.assignAccess()) return;
      if(files.length === 0) return;
      this.setProgress({message:'Guardando...',show:true});
      uploadPwoSheet({file:files[0]})
        .then(r => {
          this.setProgress({show:false});
          (r.message || '').toLowerCase() === 'success'
            ? this.setSnackbar({message: 'Guardado.', class: 'success', timeout: 0, clearable: true}) || this.reGetSheetUpdate()
            : this.setSnackbar({message: 'Problema.', class: 'error', timeout: 0, clearable: true});
        })
        .catch(e => this.getError(e));
		},
  },
};
</script>
